/* eslint-disable import/no-anonymous-default-export */
import axios from "axios"
import host from "./host"

export const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
    function (rs) {
        return rs
    },
    function (err) {
        if (err?.response?.data?.redirect_to_login) {
            localStorage.removeItem("user")
            localStorage.removeItem('token')
            const refirectRoute = window.location.origin + '/login'
            window.location.href = refirectRoute
        } else if (err?.response?.data?.error) {
            alert(err?.response?.data?.error, 'error')
        }
        return Promise.reject(err)
    }
)

const path = {
    auth: "/api/auth-users",
    answers: "answers",
    attachments: "/api/attachments",
    notifications: "/api/notifications",
    users: "/api/users",
    user_config: "/api/user-configs",
    permission: "/api/permissions",
    client: "/api/clients",
    campaign: "/api/campaigns",
    quiz: "/api/quizzes",
    enums: "/api/enums",
    day: "/api/days",
    content: "/api/contents",
    categories: "/api/categories",
    questions: "questions",
    day_events: "/api/day-events",
    prospects: "/api/prospects",
    gymWorkouts: "/api/gym-workouts",
    gymExercises: "/api/gym-exercises",
    homeWorkouts: "/api/home-workouts",
    homeExercises: "/api/home-exercises",
    stretchings: "/api/stretchings",
    stretchingExercises: "/api/stretching-exercises",
    diets: "/api/diets"
}

export default {
    auth: {
        // validateUserSession: params => {
        //     return axiosInstance.get(`${host}${path.auth}/validade-session`, {params})
        // },
        authenticate: body => {
            return axiosInstance.post(`${host}${path.auth}/authenticate-panel`, body)
        },
        forgotPassword: email => {
            return axiosInstance.post(`${host}${path.auth}/reset-password/${email}`)
        },
        changePassword: body => {
            return axiosInstance.put(`${host}${path.auth}/change-password`, body);
        },
        changePasswordForced: body => {
            return axiosInstance.put(`${host}${path.auth}/change-password-forced/`, body);
        },
        resetPasswordForced: (body, token) => {
            return axiosInstance.put(`${host}${path.auth}/change-password-forced/`, body, { headers: { common: { ['Authorization']: `Bearer ${token}` } } });
        },
        listUsers: () => {
            return axiosInstance.get(`${host}${path.auth}/`);
        },
        setAuthorizationToken: async (formatedToken) => {
            axiosInstance.defaults.headers.common.Authorization = formatedToken
            localStorage.setItem('token', formatedToken)
            return
        },
        removeAuthorizationToken: async () => {
            axiosInstance.defaults.headers.common.Authorization = null
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            return
        },
        resetPassword: id => {
            return axiosInstance.post(`${host}${path.auth}/reset-password-painel/${id}`)
        },
        currentUser: () => {
            return axiosInstance.get(`${host}${path.auth}/current-user-painel`)
        },
    },

    answers: {
        list: (quiz_id, question_id) => axiosInstance.get(`${host}${path.quiz}/${quiz_id}/${path.questions}/${question_id}/${path.answers}`)
    },

    user: {
        changeActive: id => {
            return axiosInstance.put(`${host}${path.users}/change-active/${id}`)
        },
        changeNeedAppointment: id => {
            return axiosInstance.put(`${host}${path.users}/change-need-appointment/${id}`)
        },
        update: body => {
            return axiosInstance.put(`${host}${path.users}/${body.id}`, body)
        },
        
        createAdmin: body => {
            return axiosInstance.post(`${host}${path.users}/admin`, body)
        },
        create: body => {
            return axiosInstance.post(`${host}${path.users}`, body)
        },
        listAdmin: (params) => {
            return axiosInstance.get(`${host}${path.users}/list-admin`, { params });
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.users}/list`, { params });
        },
        get: id => {
            return axiosInstance.get(`${host}${path.users}/app/${id}`)
        },
        changeLastAppointment: id => {
            return axiosInstance.put(`${host}${path.users}/change-last-appointment-interest/${id}`)
        }
    },

    attachments: {
        createForContent: (formData) => {
            return axiosInstance.post(`${host}${path.attachments}/3`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        },
        createForDiet: (formData) => {
            return axiosInstance.post(`${host}${path.attachments}/1`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        },
        createForTraining: (formData) => {
            return axiosInstance.post(`${host}${path.attachments}/2`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.attachments}/list`, { params });
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.attachments}/${id}`)
        }
    },

    notifications: {
        listAll: (params) => {
            return axiosInstance.get(`${host}${path.notifications}/`, { params });
        },
        find: id => {
            return axiosInstance.get(`${host}${path.notifications}/${id}`);
        },
        create: body => {
            return axiosInstance.post(`${host}${path.notifications}/`, body);
        },
        markAllAsRead: () => {
            return axiosInstance.put(`${host}${path.notifications}/read`);
        },
        markOneAsRead: id => {
            return axiosInstance.put(`${host}${path.notifications}/read/${id}`);
        },
    },
    prospects: {
        create: body => {
            return axiosInstance.post(`${host}${path.prospects}/`, body);
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.prospects}/list`, { params });
        },
        turnClient: (id) => {
            return axiosInstance.put(`${host}${path.prospects}/turn-client/${id}` );
        },
        turnProspect: (id) => {
            return axiosInstance.put(`${host}${path.prospects}/turn-prospect/${id}` );
        },
    },
    client: {
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.client}/${id}`, body)
        },
        create: body => {
            return axiosInstance.post(`${host}${path.client}`, body)
        },
        listClients: params => {
            return axiosInstance.get(`${host}${path.client}/list/${params}`);
        },
        get: userId => {
            return axiosInstance.get(`${host}${path.client}/${userId}`)
        },
        changeActive: id => {
            return axiosInstance.put(`${host}${path.client}/change-active/${id}`)
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.client}/`, { params });
        },
        find: (id, params) => {
            return axiosInstance.get(`${host}${path.client}/${id}`, { params });
        },
        unlinkCampaign: (id, body) => {
            return axiosInstance.post(`${host}${path.client}/unlink-campaign/${id}`, body)
        },
        associateQuiz: body => {
            return axiosInstance.post(`${host}${path.client}/associate-quiz`, body)
        },
        unlinkQuiz: quizClientId => {
            return axiosInstance.post(`${host}${path.client}/unlink-quiz/${quizClientId}`, null)
        },
    },

    campaign: {
        create: body => {
            return axiosInstance.post(`${host}${path.campaign}`, body)
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.campaign}/`, { params });
        },
        find: id => {
            return axiosInstance.get(`${host}${path.campaign}/${id}`)
        },
        associateClients: body => {
            return axiosInstance.post(`${host}${path.campaign}/associate-clients`, body)
        },
        associateQuizz: body => {
            return axiosInstance.post(`${host}${path.campaign}/associate-quiz`, body)
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.campaign}/${id}`, body)
        },
    },

    day: {
        create: body => {
            return axiosInstance.post(`${host}${path.day}`, body)
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.day}/`, { params });
        },
        find: id => {
            return axiosInstance.get(`${host}${path.day}/${id}`)
        },
    },

    content: {
        create: (body) => {
            return axiosInstance.post(`${host}${path.content}/`, body)
        },
        update: (content_id, body) => {
            return axiosInstance.put(`${host}${path.content}/${content_id}`, body)
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.content}/`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.content}/${id}`)
            // return Promise.resolve({ data: { name: 'teste', description: 'Lorem', weeks: 1, days: [] } })
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.content}/${id}`)
        }
    },

    enums: {
        list: () => {
            return axiosInstance.get(`${host}${path.enums}/`);
        },
        find: name => {
            return axiosInstance.get(`${host}${path.enums}/${name}`);
        },
    },

    quiz: {
        create: body => {
            return axiosInstance.post(`${host}${path.quiz}`, body)
        },
        list: (params) => {
            return axiosInstance.get(`${host}${path.quiz}/`, { params });
        },
        listQuizClients: (params) => {
            return axiosInstance.get(`${host}${path.quiz}/clients/`, { params });
        },
        listDashboard: (params) => {
            return axiosInstance.get(`${host}${path.quiz}/dashboard`, { params });
        },
        listRankingAnswerTypes: () => {
            return axiosInstance.get(`${host}${path.quiz}/ranking-answer-types`);
        },
        find: id => {
            return axiosInstance.get(`${host}${path.quiz}/${id}`);
        },
        findDashboard: (id, params) => {
            return axiosInstance.get(`${host}${path.quiz}/dashboard/${id}`, { params });
        },
        findDashboardAnswers: (quiz_client_id, question_id, params) => {
            return axiosInstance.get(`${host}${path.quiz}/dashboard-answers/${quiz_client_id}/${path.questions}/${question_id}`, { params });
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.quiz}/${id}`, body)
        },
        export: (quiz_id, params) => axiosInstance.get(`${host}${path.quiz}/export-answers-excel/${quiz_id}`, { params }),
        rankingTypes: (params) => {
            return axiosInstance.get(`${host}${path.quiz}/ranking-answer-types/`, { params })
        },
    },

    questions: {
        create: (quiz_id, body) => {
            return axiosInstance.post(`${host}${path.quiz}/${quiz_id}/${path.questions}`, body)
        },
        update: (quiz_id, question_id, body) => {
            return axiosInstance.put(`${host}${path.quiz}/${quiz_id}/${path.questions}/${question_id}`, body)
        },
        list: (quiz_id, params) => {
            return axiosInstance.get(`${host}${path.quiz}/${quiz_id}/${path.questions}/`, { params });
        },
        find: (quiz_id, id, params) => {
            return axiosInstance.get(`${host}${path.quiz}/${quiz_id}/${path.questions}/${id}`, { params })
        },
        delete: (quiz_id, id) => {
            return axiosInstance.delete(`${host}${path.quiz}/${quiz_id}/${path.questions}/${id}`)
        },
    },

    categories: {
        list: () => {
            return axiosInstance.get(`${host}${path.categories}/`);
        },
        find: id => {
            // return axiosInstance.get(`${host}${path.client}/${id}`)
            return Promise.resolve({ data: { name: 'teste', description: 'Lorem', weeks: 1, days: [] } })
        },
    },

    dayEvents: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.day_events}/`, { params });
        },
    },

    // ========== TREINOS NA ACADEMIA ==========
    gymWorkouts: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.gymWorkouts}/`, { params });
        },
        listApp: (params) => {
            return axiosInstance.get(`${host}${path.gymWorkouts}/app`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.gymWorkouts}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.gymWorkouts}/`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.gymWorkouts}/${id}`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.gymWorkouts}/${id}`);
        },
        getEnums: () => {
            return axiosInstance.get(`${host}${path.gymWorkouts}/enums`);
        },
    },

    gymExercises: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.gymExercises}/`, { params });
        },
        listByWorkout: (workoutId, params) => {
            return axiosInstance.get(`${host}${path.gymExercises}/workout/${workoutId}`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.gymExercises}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.gymExercises}/`, body);
        },
        bulkCreate: (body) => {
            return axiosInstance.post(`${host}${path.gymExercises}/bulk`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.gymExercises}/${id}`, body);
        },
        reorder: (body) => {
            return axiosInstance.put(`${host}${path.gymExercises}/reorder`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.gymExercises}/${id}`);
        },
    },

    // ========== TREINOS EM CASA ==========
    homeWorkouts: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.homeWorkouts}/`, { params });
        },
        listApp: (params) => {
            return axiosInstance.get(`${host}${path.homeWorkouts}/app`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.homeWorkouts}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.homeWorkouts}/`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.homeWorkouts}/${id}`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.homeWorkouts}/${id}`);
        },
    },

    homeExercises: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.homeExercises}/`, { params });
        },
        listByWorkout: (workoutId, params) => {
            return axiosInstance.get(`${host}${path.homeExercises}/workout/${workoutId}`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.homeExercises}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.homeExercises}/`, body);
        },
        bulkCreate: (body) => {
            return axiosInstance.post(`${host}${path.homeExercises}/bulk`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.homeExercises}/${id}`, body);
        },
        reorder: (body) => {
            return axiosInstance.put(`${host}${path.homeExercises}/reorder`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.homeExercises}/${id}`);
        },
    },

    // ========== ALONGAMENTOS ==========
    stretchings: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.stretchings}/`, { params });
        },
        listApp: (params) => {
            return axiosInstance.get(`${host}${path.stretchings}/app`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.stretchings}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.stretchings}/`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.stretchings}/${id}`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.stretchings}/${id}`);
        },
    },

    stretchingExercises: {
        list: (params) => {
            return axiosInstance.get(`${host}${path.stretchingExercises}/`, { params });
        },
        listByStretching: (stretchingId, params) => {
            return axiosInstance.get(`${host}${path.stretchingExercises}/stretching/${stretchingId}`, { params });
        },
        find: (id) => {
            return axiosInstance.get(`${host}${path.stretchingExercises}/${id}`);
        },
        create: (body) => {
            return axiosInstance.post(`${host}${path.stretchingExercises}/`, body);
        },
        bulkCreate: (body) => {
            return axiosInstance.post(`${host}${path.stretchingExercises}/bulk`, body);
        },
        update: (id, body) => {
            return axiosInstance.put(`${host}${path.stretchingExercises}/${id}`, body);
        },
        reorder: (body) => {
            return axiosInstance.put(`${host}${path.stretchingExercises}/reorder`, body);
        },
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.stretchingExercises}/${id}`);
        },
    },

    // ========== DIETAS ==========
    diets: {
        // Lista opções disponíveis (gênero, tipo, quantidade de refeições)
        getEnums: () => {
            return axiosInstance.get(`${host}${path.diets}/enums`);
        },
        // Lista todas as dietas (com filtros opcionais: gender, type, meals_count)
        list: (params) => {
            return axiosInstance.get(`${host}${path.diets}/`, { params });
        },
        // Busca dieta por ID
        find: (id) => {
            return axiosInstance.get(`${host}${path.diets}/find/${id}`);
        },
        // Cria nova dieta (formData com: gender, type, meals_count, description, file)
        create: (formData) => {
            return axiosInstance.post(`${host}${path.diets}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        },
        // Atualiza dieta existente (formData com: description, file)
        update: (id, formData) => {
            return axiosInstance.put(`${host}${path.diets}/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        },
        // Deleta dieta
        delete: (id) => {
            return axiosInstance.delete(`${host}${path.diets}/${id}`);
        },
        // Obtém URL para download do PDF
        getDownloadUrl: (gender, type, meals) => {
            return axiosInstance.get(`${host}${path.diets}/url/${gender}/${type}/${meals}`);
        },
    }
}
